const DATASET = [
    { id: 'clinical_trials', name: 'Clinical Trials', icon: '🔬'},
    { id: 'pubmed', name: 'PubMed', icon: '📚'},
    { id: 'fda_510k', name: 'FDA 510(k)', icon: '🏥'},
    { id: 'fda_denovo', name: 'FDA De Novo', icon: '🔰' },
    { id: 'fda_drugs', name: 'FDA Drugs', icon: '💊'},
    { id: 'fda_pma', name: 'FDA PMA', icon: '🏛️'},
    { id: 'google_patents', name: 'Google Patents', icon: '📜' },
    { id: 'company', name: 'Companies', icon: '🏢' },
  ];

  export default DATASET;
